var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("applications-list-table", {
    attrs: {
      clients: _vm.clients,
      "all-action-buttons": false,
      "show-action-buttons": false,
      "table-name": "clients",
      card: false,
      loading: _vm.loading,
    },
    on: { sort: _vm.handleSort },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }